import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  isCateringOrderCompleted,
  isDeliveryOrderDelivered,
  isDeliveryOrderDeliveredOrCancelledOrRefund,
  isDeliveryOrderPickedUpOrOutForOrArrived,
  isPickupOrderCompleted,
  isPickupOrderSentPOSCompleted,
  isPickupOrderCancelled,
  isDasherEnrouteToPickup,
  isUndelivered,
  getScheduleOrderContainerClassName,
  isDeliveryOrderPOSCompleted,
  isSentToPosCompletedOrisReadyPosInjection,
} from 'common/utilities/orderStatusUtils';
import OrderSummaryInfoDetails from 'organisms/orderSummaryInfoDetails/container/orderSummaryInfoDetails';
import { redirectToGiftCardPage } from 'common/utilities/utils';
import { getBottomPanelTemplate } from './orderSummaryBottomPanelTemplates';

import {
  displayDeliveryStatusPanelJSX,
  getDeliveryOrderRaiderDetailsViewJSX,
  getDeliveryOrderTrackingUsingGoogleMap,
  getDeliveryOrderIFramePanelJSX,
} from './orderSummaryDeliveryViewTemplates';

import {
  displayPickupStatusPanelJSX,
  getPickupOrderCancelPanelJSX,
  getPickupOrderCollectionMethodPanelJSX,
} from './orderSummaryPickupViewTemplates';

import { displayCateringStatusPanelJSX } from './orderSummaryCateringViewTemplates';

/*********************************************************************
 * Get order summary Info details
 * params -
 *********************************************************************/
export const getOrderSummaryInfoDetailsJSX = params => {
  return <OrderSummaryInfoDetails {...params} />;
};

/*********************************************************************
 * Horizontal line
 * params -
 *********************************************************************/
const horizontalLine = () => {
  return <div className='linebreak col-12'></div>;
};

/*********************************************************************
 * getOrderIdTimeWithStatusMessagePanelJSX
 * orderDetails
 *********************************************************************/
export const getOrderIdTimeWithStatusMessagePanelJSX = orderDetails => {
  const { displayOrderTime, displayOrderId } = orderDetails;

  let statusInfoText = translateWithI18Next(TRANSLATE_MAPPING_KEY?.WILL_BE_DELIVERED_AROUND)?.toUpperCase();

  return (
    <div className='idAndTime'>
      {translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_HASH)?.toUpperCase()}{' '}
      <span className='red'>{displayOrderId}</span> {statusInfoText}
      <div className='red'>{displayOrderTime}</div>
    </div>
  );
};

/*********************************************************************
 * getBottomPanelJSX
 * params
 *********************************************************************/
export const getBottomPanelJSX = params => {
  const labels = {
    saveOrderDescriptionText: TRANSLATE_MAPPING_KEY?.RECKON_TEXT,
    saveOrderButtonLabel: TRANSLATE_MAPPING_KEY?.SAVE_TO_FAVOURITE_ORDER,
  };

  return (
    <div className='col-12 bottomPanel'>
      {horizontalLine()}
      {getBottomPanelTemplate({ ...params, ...labels })}
    </div>
  );
};

/*********************************************************************
 * getCateringOrderPanelJSX
 * params
 *********************************************************************/
export const getCateringOrderPanelJSX = params => {
  const { orderDetails } = params;
  const { service } = orderDetails;

  return (
    <div className={`orderSummaryContainer row ${service}`}>
      <div className={`col-12 col-lg-8 leftPanel ${service}`}>
        <div
          className={`orderSummaryStatusContainer col-12 ${
            isCateringOrderCompleted(orderDetails) ? 'redCard' : ''
          }  ${service}`}
        >
          <div className={`orderSummaryStatusPanel col-12  ${service}`}>{displayCateringStatusPanelJSX(params)}</div>
        </div>
      </div>

      <div className={`col-12 col-lg-6 rightPanel ${service}`}>{getOrderSummaryInfoDetailsJSX(params)}</div>

      {getBottomPanelJSX(params)}
    </div>
  );
};

/*********************************************************************
 * getPickupOrderPanelJSX
 * params
 *********************************************************************/
export const getPickupOrderPanelJSX = params => {
  const { orderDetails } = params;
  const { service, isMobileView, hideCancelOrderPanel, hidePickupCheckin } = orderDetails;

  return (
    <div className={`orderSummaryContainer row ${service}`}>
      {((isPickupOrderCancelled(orderDetails) && orderDetails?.enableRetryCountForPickupOrderTracking) ||
        !isPickupOrderCancelled(orderDetails)) && (
        <div className={`col-12 col-lg-8 leftPanel ${service}`}>
          <div
            className={`orderSummaryStatusContainer col-12 ${
              isPickupOrderCompleted(orderDetails) ? 'redCard' : ''
            }  ${service}`}
          >
            <div className={`orderSummaryStatusPanel col-12  ${service}`}>{displayPickupStatusPanelJSX(params)}</div>
          </div>

          {isPickupOrderSentPOSCompleted(orderDetails) &&
            !orderDetails?.selectedPickupOrderCollectionMethod &&
            orderDetails?.pickupOrderAvailableCollectionPoints?.length > 0 &&
            hidePickupCheckin &&
            getPickupOrderCollectionMethodPanelJSX(params)}
        </div>
      )}

      <div className={`col-12 col-lg-6 rightPanel ${service}`}>
        {getOrderSummaryInfoDetailsJSX(params)}
        {!hideCancelOrderPanel && !isPickupOrderCompleted(orderDetails) && getPickupOrderCancelPanelJSX(params)}
      </div>

      {getBottomPanelJSX(params)}

      {!hideCancelOrderPanel && isMobileView && !isPickupOrderCompleted(orderDetails) && (
        <div className={`col-12 ${service} p-0px-imp`}>{horizontalLine()}</div>
      )}
    </div>
  );
};

/*********************************************************************
 * getGiftCardOrderPanelJSX
 * params
 *********************************************************************/
export const getGiftCardOrderPanelJSX = history => {
  return (
    <div className='orderSummaryContainer row giftcardorder'>
      <div className='col-12 col-lg-8 leftPanel'>
        <div className='orderSummaryStatusContainer col-12 redCard'>
          <div className='giftcard-content'>
            <div className='giftcard-success'>
              <img src={IMAGE_PATH?.ConfirmedImg} className='statusIcon' alt='tex' />
            </div>
            <div className='giftcard-success-msg'>
              {translateWithI18Next(TRANSLATE_MAPPING_KEY?.GIFT_CARD_PURCHASE_ORDER_SUCCESS_MESSAGE_PART_ONE)}
            </div>
            <div className='giftcard-success-msg'>
              {translateWithI18Next(TRANSLATE_MAPPING_KEY?.GIFT_CARD_PURCHASE_ORDER_SUCCESS_MESSAGE_PART_TWO)}
            </div>
            <div className='giftcard-success-status'>
              {translateWithI18Next(TRANSLATE_MAPPING_KEY?.GIFT_CARD_PURCHASE_MSG)}
            </div>
            <div className='gift-card-button'>
              <button
                data-testid='gift-card-button'
                className='button giftcard-button'
                onClick={() => redirectToGiftCardPage({ history }, false, true)}
              >
                {translateWithI18Next(TRANSLATE_MAPPING_KEY?.RETURN_TO_GIFT_CARD)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/*********************************************************************
 * getDeliveryOrderPanelJSX
 * params
 *********************************************************************/
export const getDeliveryOrderPanelJSX = params => {
  const { orderDetails } = params;
  const {
    service,
    isMobileView,
    enableCancelOrderCallsupportModal,
    showDeliveryTrackingMap,
    showDeliveryOrderRaiderDetailsView,
    showOrderSummaryInfoDetails,
  } = orderDetails;

  return (
    <div className={`orderSummaryContainer row ${service}`}>
      <div
        className={`col-12 ${
          isDeliveryOrderDelivered(orderDetails) && !showOrderSummaryInfoDetails ? 'col-lg-8 m-auto' : 'col-lg-6'
        } leftPanel ${service}`}
      >
        <div
          className={`orderSummaryStatusContainer col-12 ${
            isDeliveryOrderDeliveredOrCancelledOrRefund(orderDetails) ? 'redCard' : ''
          } ${
            isDeliveryOrderPOSCompleted(orderDetails) || isDasherEnrouteToPickup(orderDetails)
              ? getScheduleOrderContainerClassName(orderDetails)
              : 'dasher-dropoff-updated'
          } `}
        >
          <div className='orderSummaryStatusPanel col-12'>{displayDeliveryStatusPanelJSX(params)}</div>
        </div>

        {showDeliveryTrackingMap &&
          isMobileView &&
          (isDeliveryOrderPickedUpOrOutForOrArrived(orderDetails) || isUndelivered(orderDetails)) && (
            <div className='mt-20px'>{orderTrackerMapDisplay(params)}</div>
          )}

        {showDeliveryOrderRaiderDetailsView && getDeliveryOrderRaiderDetailsViewJSX(params)}

        {!isMobileView && (isDeliveryOrderPickedUpOrOutForOrArrived(orderDetails) || isUndelivered(orderDetails)) && (
          <>{getOrderSummaryInfoDetailsJSX(params)}</>
        )}
      </div>
      {isDeliveryOrderDelivered(orderDetails) && showOrderSummaryInfoDetails && (
        <div className={`col-12 col-lg-6 rightPanel ${service}`}>{getOrderSummaryInfoDetailsJSX(params)}</div>
      )}
      <div className={`col-12 col-lg-6 rightPanel ${service}`}>
        {!isDeliveryOrderDelivered(orderDetails) &&
          (showDeliveryTrackingMap &&
          !isMobileView &&
          (isDeliveryOrderPickedUpOrOutForOrArrived(orderDetails) || isUndelivered(orderDetails)) ? (
            orderTrackerMapDisplay(params)
          ) : (
            <>
              {getOrderSummaryInfoDetailsJSX(params)}
              {enableCancelOrderCallsupportModal &&
                (isSentToPosCompletedOrisReadyPosInjection(orderDetails) || isDasherEnrouteToPickup(orderDetails)) &&
                getPickupOrderCancelPanelJSX(params)}
            </>
          ))}
      </div>

      {getBottomPanelJSX(params)}
    </div>
  );
};

export const orderTrackerMapDisplay = params => {
  const { orderDetails } = params;
  return orderDetails?.showOrderTrackingIFrame
    ? getDeliveryOrderIFramePanelJSX(params)
    : getDeliveryOrderTrackingUsingGoogleMap(params);
};
